import { render, staticRenderFns } from "./livePromotionIndex.vue?vue&type=template&id=9e3ced1c&scoped=true&"
import script from "./livePromotionIndex.vue?vue&type=script&lang=js&"
export * from "./livePromotionIndex.vue?vue&type=script&lang=js&"
import style0 from "./livePromotionIndex.vue?vue&type=style&index=0&id=9e3ced1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3ced1c",
  null
  
)

export default component.exports